import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Enhanced Excel Export Utility
 * Support single sheet: exportDataToExcel(array, "SheetName", "File.xlsx")
 * Support multiple sheets: exportDataToExcel({ "Sheet1": array1, "Sheet2": array2 }, null, "File.xlsx")
 */
export const exportDataToExcel = (data, sheetName = "Report", fileName = "Report.xlsx") => {
    const workbook = XLSX.utils.book_new();

    if (Array.isArray(data)) {
        // Single Sheet Mode
        const worksheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || "Report");
    } else if (typeof data === 'object' && data !== null) {
        // Multiple Sheets Mode
        Object.entries(data).forEach(([name, sheetData]) => {
            const worksheet = XLSX.utils.json_to_sheet(sheetData);
            XLSX.utils.book_append_sheet(workbook, worksheet, name);
        });
    }

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(fileData, fileName);
};
